import { useState, useEffect } from 'react';

const BREAKPOINTS = {
    PHONE: 'phone',
    TABLET: 'tablet',
    LAPTOP: 'laptop',
    DESKTOP: 'desktop',
    DESKTOP_XL: 'desktopxl',
};
const getCssBreakpoints = () => {
    if (typeof window === 'undefined')
        return {};
    const rootStyles = window.getComputedStyle(document.documentElement);
    const breakpoints = {};
    Object.keys(BREAKPOINTS).map((key) => {
        const breakpointKey = BREAKPOINTS[key];
        const cssVariable = `--breakpoint-${breakpointKey}`;
        const value = parseInt(rootStyles.getPropertyValue(cssVariable).trim());
        if (!Number.isNaN(value))
            breakpoints[breakpointKey] = value;
        return breakpoints;
    });
    return breakpoints;
};
const breakpoints = getCssBreakpoints();
const getBreakpoint = (breakpoint) => breakpoints[breakpoint];
const checkBreakpoint = (width, breakpoint) => {
    const keys = Object.keys(breakpoints);
    const index = keys.indexOf(breakpoint);
    const breakpointLow = breakpoints[keys[index]];
    const breakpointHight = breakpoints[keys[index + 1]];
    if (breakpointHight)
        return width < breakpointHight && width >= breakpointLow;
    return width >= breakpointLow;
};
const isBreakpoint = (breakpoint) => {
    if (typeof window === 'undefined')
        return false;
    const width = window.innerWidth;
    return checkBreakpoint(width, breakpoint);
};
const getCurrentBreakpoint = () => {
    if (typeof window === 'undefined')
        return;
    const width = window.innerWidth;
    const keys = Object.keys(breakpoints);
    for (let index = 0; index < keys.length; index += 1) {
        const key = keys[index];
        if (checkBreakpoint(width, key)) {
            return { key, value: breakpoints[key], index };
        }
    }
};
const useResize = () => {
    const defaultBreakpoint = {
        key: 'phone',
        value: breakpoints.phone,
        index: 0,
    };
    const [size, setSize] = useState([
        0,
        0,
        defaultBreakpoint,
    ]);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const getSize = () => setSize([
            window.innerWidth,
            window.innerHeight,
            getCurrentBreakpoint() || defaultBreakpoint,
        ]);
        getSize();
        window.addEventListener('resize', getSize);
        return () => window.removeEventListener('resize', getSize);
    }, []);
    return size;
};
const getResponsiveClass = (value, prefix, index) => {
    if (!value)
        return '';
    const suffix = Array.isArray(value)
        ? value[Math.min(index, value.length - 1)]
        : value;
    return `${prefix}__${suffix}`;
};

export { BREAKPOINTS, getBreakpoint, getCurrentBreakpoint, getResponsiveClass, isBreakpoint, useResize };
